import { createSlice } from "@reduxjs/toolkit";

const initialStaffUsersState = {
  listLoading: false,
  actionsLoading: false,
  searchData: {},
  staffUserForEdit: {},
  lastError: null,
  gameData: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const SelectComponentsSlice = createSlice({

  name: "searchList",
  initialState: initialStaffUsersState,
  reducers: {
    catchError: (state, action) => {
      console.log('action::', 'catchError')
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      console.log('action::', 'startCall')
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // search list
    searchListFetched: (state, action) => {
      
      const { entities, source } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.searchData[source] = entities;
    },
    searchGameTypeListFetched: (state, action) => {
      
      const { entities, source, gameData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.searchData[source] = entities;
      state.gameData = gameData;
    },

    saveCompany: (state, action) => {
      state.companyData = action.payload;
    },
    
  }
});
